import { render, staticRenderFns } from "./GeneralScoreSave.vue?vue&type=template&id=f3d3a9c6&"
import script from "./GeneralScoreSave.vue?vue&type=script&lang=js&"
export * from "./GeneralScoreSave.vue?vue&type=script&lang=js&"
import style0 from "./GeneralScoreSave.vue?vue&type=style&index=0&id=f3d3a9c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports